module.exports = __webpack_public_path__ + "img/Eye.cf7cdb05.svg";